var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Calling"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calling"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    d: "M9.56866 1.1665C12.036 1.4405 13.9853 3.38717 14.262 5.8545",
    stroke: "#9E9BAC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3",
    d: "M9.56866 3.52832C10.7493 3.75765 11.672 4.68099 11.902 5.86165",
    stroke: "#9E9BAC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35433 7.81476C10.0137 10.4734 10.6169 7.39765 12.3101 9.08971C13.9425 10.7217 14.8814 11.0486 12.8125 13.1163C12.5535 13.3245 10.9075 15.8293 5.12296 10.0463C-0.662291 4.2625 1.84102 2.6148 2.04928 2.3558C4.12249 0.282401 4.44453 1.22609 6.07691 2.85806C7.7694 4.55083 4.695 5.15611 7.35433 7.81476Z",
    stroke: "#9E9BAC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalling);
export default __webpack_public_path__ + "static/media/Calling.470289054d425d9458310d8a47221a83.svg";
export { ForwardRef as ReactComponent };